import { render } from "./loginComponent.vue?vue&type=template&id=a1977154"
import script from "./loginComponent.vue?vue&type=script&lang=js"
export * from "./loginComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__